export default {
  'invoicePaymentCondition.label.payments': 'Pagamentos',
  'invoicePaymentCondition.label.exchangeValue': 'Valor Troco',
  'invoicePaymentCondition.label.billingData': 'Dados para Cobrança',
  'invoicePaymentCondition.label.invoiceNumber': 'Número Fatura',
  'invoicePaymentCondition.label.originalValue': 'Valor Original',
  'invoicePaymentCondition.label.discountValue': 'Valor Desconto',
  'invoicePaymentCondition.label.netValue': 'Valor Líquido',

  'invoicePaymentCondition.column.paymentType': 'Tipo Pagamento',
  'invoicePaymentCondition.column.value': 'Valor',
  'invoicePaymentCondition.column.flagCard': 'Bandeira Cartão',
  'invoicePaymentCondition.column.authorizationNumber': 'Número Autorização',
  'invoicePaymentCondition.column.installmentNumber': 'Número Parcela',
  'invoicePaymentCondition.column.expirationDate': 'Data de Vencimento',
  'invoicePaymentCondition.column.installmentValue': 'Valor da Parcela',

  'invoicePaymentCondition.button.newPayment': 'Novo Pagamento',
  'invoicePaymentCondition.button.newInstallment': 'Nova Parcela',
  'invoicePaymentCondition.button.multipleInstallments': 'Multiplas Parcelas',

  'invoice.invoicePaymentCondition.notifications.success.title': 'Sucesso!',
  'invoice.invoicePaymentCondition.notifications.create.success.description':
    'Pagamento criado!',
  'invoice.invoicePaymentCondition.notifications.delete.success.description':
    'Pagamento removido!',
  'invoice.invoicePaymentCondition.notifications.update.success.description':
    'Pagamento atualizado!',
};
